import { render } from "./TermOfUse.vue?vue&type=template&id=969fb4ca&scoped=true"
import script from "./TermOfUse.vue?vue&type=script&lang=js"
export * from "./TermOfUse.vue?vue&type=script&lang=js"

import "./TermOfUse.vue?vue&type=style&index=0&id=969fb4ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969fb4ca"]])

export default __exports__